import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndustryTypeService {

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) { }

  getIndustryTypes(payload:any):Observable<any> {
    let param = new HttpParams();
    param = param.append('limit', payload.limit);
    param = param.append('currentPage', payload.currentPage)
    return this.http.get<any>(this.apiUrlService.GET_INDUSTRY_TYPE, { params: param});
  }

}
